/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/


import {
  LOGIN_GOOGLE_REQUEST,
  LOGIN_GOOGLE_SUCCESS,
  LOGIN_GOOGLE_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  SET_PROFILE,
  PROFILE_REQUEST,
  PROFILE_SUCCESS,
  PROFILE_FAILURE,
  CHANGE
} from '../actions/actionTypes'


const initialState = {
  user:window.user ? window.user : {}
}
const authReducer = function(state = initialState, action) {
  // const request = action.request;
  // const response = action.response;
  switch(action.type) {
    case LOGIN_GOOGLE_REQUEST:
      return {
        ...state,
        user:{}
      }

    case LOGIN_GOOGLE_SUCCESS:
      return{
        ...state,
        user:action.response
      }

    case LOGIN_GOOGLE_FAILURE:
    // TODO: handle this
      return {
        ...state,
        user:{}
      }

    case LOGOUT_REQUEST:
      return {
        ...state,
        user:{}
      }

    case LOGOUT_SUCCESS:
      window.user = {};
      return{
        ...state,
        user:{}
      }

    case LOGOUT_FAILURE:
      return {
        ...state,
        user:{}
      }
    case PROFILE_REQUEST:
      return state//{...state, user:action.request.body }//state, it should actually be just sate, but setFeeds is called before profile_success, messing things up

    case PROFILE_SUCCESS:
      let body = action.request.body
      // console.log(action)
      // console.log('action.response')
      // console.log(body)

      // console.log(state)
      if(body.feeds && !Array.isArray(body.feeds)){
        let newUser = JSON.parse(JSON.stringify(state.user))
        let feedIndex = newUser.feeds.findIndex(f=>f.id===body.feeds.id)


        if(body.feeds.delete){
          newUser.feeds[feedIndex] = null
          newUser.feeds = newUser.feeds.filter(f=>f)
        }else if(body.feeds.new && action.response.newId){
          delete body.feeds.new
          let newFeed = JSON.parse(JSON.stringify(body.feeds))
          newFeed.id = action.response.newId
          newUser.feeds.push(newFeed)
        }else{
          // console.log(newUser.feeds[feedIndex])
          // console.log(body.feeds)
          // let updatedFeed = JSON.parse(JSON.stringify(body.feeds))
          // updatedFeed.menu = newUser.feeds[feedIndex].menu
          // newUser.feeds[feedIndex] = updatedFeed
          if(feedIndex>-1){
            // console.log(newUser.feeds)
            newUser.feeds[feedIndex] = JSON.parse(JSON.stringify(body.feeds))
            // console.log(body.feeds)
            // console.log(newUser.feeds[feedIndex])
            newUser.feeds[feedIndex].focus=true
          }
        }

        return {...state, user:newUser}
      }else if(body.websites && body.websites.url){
        let newUser = JSON.parse(JSON.stringify(state.user))
        let websiteIndex = newUser.websites.findIndex(f=>f.url===body.websites.url)
        websiteIndex>-1 ? newUser.websites[websiteIndex] = JSON.parse(JSON.stringify(body.websites)) :  newUser.websites.push(JSON.parse(JSON.stringify(body.websites)))
        return {...state, user:newUser}
      }else{
        
        let newUser = body.partial ? {...JSON.parse(JSON.stringify(state.user)), ...JSON.parse(JSON.stringify(action.request.body))} : JSON.parse(JSON.stringify(action.request.body))
        return {...state, user:newUser}
      }

    case PROFILE_FAILURE:
      return state
   
    case SET_PROFILE:
    // console.log('SETTING A PROFILE IN REDUCER')
          return {user: {...state.user, ...action.request.body}}

    case CHANGE:
          return {...state, saved:true}       

    default: return state
  }
}

export default authReducer;